import { createRouter, createWebHistory } from 'vue-router'
import type { RouteLocationNormalized, Router, RouteRecordRaw } from 'vue-router'

import publicRoutes from './public'
import privateRoutes from './private'
import MiddlewareProvider from './middlewares'

const routes: readonly RouteRecordRaw[] = [
  ...publicRoutes,
  ...privateRoutes,
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

MiddlewareProvider.register(router, [])

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $router: Router
    $route: RouteLocationNormalized
  }
}

export { router }
